var map = {
	"./Layout.png": 83792,
	"./fb.png": 54464,
	"./idImages/aj.png": 94769,
	"./idImages/allen.png": 73602,
	"./idImages/alyzza.png": 75684,
	"./idImages/april.png": 3883,
	"./idImages/charish.png": 5056,
	"./idImages/chris.png": 2319,
	"./idImages/julius.webp": 23834,
	"./idImages/kian.png": 72052,
	"./idImages/matthew.png": 64367,
	"./idImages/orland.png": 4820,
	"./idImages/paul.png": 15377,
	"./idImages/rashmin.png": 89168,
	"./internet.png": 85955,
	"./mail.png": 84123
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10704;